export const aciSeparatBedrooms = {
    iconName: 'separat-bedrooms',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: [
            {
                attr: {
                    d: 'M7.593 3.54h9.776a.752.752 0 01.752.752V20.46H6.84V4.292a.752.752 0 01.752-.752zM4.585 20.46h15.792',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M15.3 12.282a.282.282 0 110-.564M15.3 12.282a.282.282 0 000-.564',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                },
            },
        ],
    },
};
